// amplitude.ts
'use client'
import * as amplitude from '@amplitude/unified'
import { AMPLITUDE_API_KEY } from '@/utils/constants'

async function initAmplitude() {
  if (!AMPLITUDE_API_KEY) return

  try {
    await amplitude.initAll(AMPLITUDE_API_KEY, {
      analytics: {
        autocapture: {
          elementInteractions: true,
          sessions: true,
          networkTracking: true,
        },
      },
    })
  } catch (error) {
    console.error('Error initializing Amplitude', error)
  }
}
if (typeof window !== 'undefined') {
  void initAmplitude()
}
export const Amplitude = () => null

export default amplitude
